import { Button } from "@tremor/react";
import PropTypes from "prop-types";
import { Link, useNavigate } from "react-router-dom";

export const TitleTablePage = ({ title, urlToGo, titleBtn }) => {
  const navigate = useNavigate();
  const goToView = () => {
    navigate(`/${urlToGo}`);
  };
  return (
    <>
      <div className="flex justify-between my-3">
        <h1 className="text-3xl">{title}</h1>
        <Button onClick={goToView}>{titleBtn}</Button>
      </div>
    </>
  );
};

TitleTablePage.propTypes = {
  title: PropTypes.string,
  titleBtn: PropTypes.string,
  urlToGo: PropTypes.string,
};
